<script setup>
import { watch, ref, onMounted } from 'vue';
import { storeToRefs } from "pinia";
import { useFVStore } from '../../../stores/formvibes';
import Conditions from './conditions.vue';
import status from './status.vue';
import { Plus,CloseBold, RefreshRight } from "@element-plus/icons-vue"
import { deleteFromLocalStorage, getFromLocalStorage, setToLocalStorage } from '../../../stores/utils';

const props = defineProps([ 'closeClick',]);

const store = useFVStore();
const i18n = window.fvGlobalVar?.i18n;
const {generalStates, tableData,formColumns,submissionCount} = storeToRefs(store);

const storedFilters = getFromLocalStorage('fv-filters')?.['filters'];

const filters = ref( [{
            filter: '',
            key: '',
            operator: 'LIKE',
            value: '',
        }]);

onMounted(() => {
    if(storedFilters) {
        filters.value = storedFilters;
    }
});
const filterRelation = [
    {
        value: 'and', label: 'AND', icon: ''
    },
    {
        value: 'or', label: 'OR', icon: ''
    },
];

const addFilter = (e) => {
    filters.value= [
        ...filters.value,
        {
            filter: '',
            key: '',
            operator: 'LIKE',
            value: '',
        }
    ];
}

const removeFilter = (e,id) => {
    filters.value = filters.value.filter((filter, i) => i !== id);
}

const applyFilter = (e) => {
    generalStates.value.queryParams.query_filters = filters.value;
    generalStates.value.queryParams.page_num = 1;
    //console.log('filters', filters.value);

    store.fetchData();

    setToLocalStorage('fv-filters', {
        filters: filters.value,
        status: generalStates.value.queryParams.status,
        filterRelation: generalStates.value.queryParams.filter_relation,
        selectedStatus: generalStates.value.queryParams.selectedStatus,
    });
}

const resetFilter = () => {
    filters.value = [{
        filter: '',
        key: '',
        operator: 'LIKE',
        value: '',
    }];
    deleteFromLocalStorage('fv-filters');
    generalStates.value.queryParams = {
        ...generalStates.value.queryParams,
        status: [],
        filter_relation: 'OR',
        selectedStatus: [],
        query_filters: filters.value,
    }
}

</script>
<template>
    <div class="fv-submissions-filter-wrapper">
        <el-icon class="fv-close-filter" @click="closeClick"><CloseBold /></el-icon>
        <div style="width:70%;">
            <div class="fv-form-row" v-if="generalStates.queryParams.plugin !== 'caldera'">
                <status />
            </div>
            <div className="fv-sf-conditions">
                <div className="fv-form-row">
                    <div class="fv-form-row-label">
                        {{ 
                            generalStates.queryParams.filter_relation ? 
                            i18n?.or_condition_met_msg : i18n?.and_condition_met_msg
                        }}
                    </div>
                    <div class="fv-form-row-value">
                        <el-select v-model="generalStates.queryParams.filter_relation" placeholder="OR">
                        <el-option
                            v-for="item in filterRelation"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                    </div>
                </div>
                <Conditions v-for="(filter,index) in filters" :filterData="filter" :key="index" :removeFilter="removeFilter" :id="index" :columns="formColumns" />
                <div @click="addFilter" class="fv-add-condition">
                    <el-icon><Plus /></el-icon>
                    <span>{{i18n?.add_new_condition}}</span>
                </div>
                <div class="fv-filter-action">
                    <el-button type="primary" @click="applyFilter">Apply Filter</el-button>
                    <el-button type="danger" @click="resetFilter" :icon="RefreshRight" plain class="fv-filter-reset">Reset</el-button>
                    <el-tag type="primary" v-if="submissionCount != ''">{{submissionCount}}</el-tag>
                </div>
            </div>
        </div>
    </div>   
        
</template>